<template>
    <div class="message-create-modal">
        <b-modal :id="modalId" no-close-on-backdrop no-close-on-esc>
            <template #modal-header>
                <h3>Message to {{ recipient ? recipient.full_name : '' }}</h3>
            </template>
            <template>
                <b-form-group :invalid-feedback="invalidFeedback">
                    <h4>Subject:</h4>
                    <b-form-input
                        v-model="message.subject"
                        placeholder="Subject"
                        :state="subjectState"
                    />
                    <h4 style="margin-top: 15px">Message:</h4>
                    <b-form-textarea
                        v-model="message.body"
                        placeholder="Type your message here"
                        :state="bodyState"/>
                </b-form-group>
            </template>

            <template #modal-footer>
                <b-btn variant="danger" @click="closeModal">
                    Cancel
                    <b-icon-x-square/>
                </b-btn>
                <b-btn variant="primary" @click="sendMessage(false)">
                    Save as Draft
                    <b-icon-arrow-bar-down/>
                </b-btn>
                <b-btn variant="success" @click="sendMessage(true)">
                    Send
                    <b-icon-box-arrow-right/>
                </b-btn>
            </template>
        </b-modal>
    </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
    name: 'MessageCreateModal',
    props: {
        modalId: String,
        recipient: Object,
        draft: Object,
    },
    data () {
        return {
            message: {
                from_id: this.$store.state.currentUser.id,
                to_id: this.recipient ? this.recipient.id : null,
                subject: this.draft ? this.draft.subject : null,
                body: this.draft ? this.draft.body : null,
                status: 'UNREAD',
                sent: null
            },
        }
    },
    computed: {
        invalidFeedback () {
            let feedback = ''
            if (!this.message.subject) {
                feedback += 'Please enter a subject line. '
            }
            if (!this.message.body) {
                feedback += 'Please enter a message body.'
            }
            return feedback
        },
        subjectState () {
            if (!this.message.subject) {
                return false
            } else {
                return null
            }
        },
        bodyState () {
            if (!this.message.body) {
                return false
            } else {
                return null
            }
        },
    },
    watch: {
        draft: function (newDraft, oldDraft) {
            this.message.subject = newDraft.subject
            this.message.body = newDraft.body
        }
    },
    methods: {
        /**
         * @param send of type boolean will send if true, save as draft otherwise
         */
        sendMessage (send) {
            if (this.subjectState !== false && this.bodyState !== false) {
                if (send) {
                    this.message.to_id = this.recipient.id
                    this.message.sent = this.getDateTime()
                    this.$api.sendMessageEmail(this, this.message)
                }
                if (this.draft) {
                    this.message.id = this.draft.id
                    this.message.to_id = this.draft.to_id
                    this.message.created = this.draft.created
                    this.message.toUser = this.draft.toUser
                    this.$api.updateItem(this, 'message', this.message)
                } else {
                    this.$api.createItem(this, 'message', this.message)
                }
                this.closeModal()
                this.refreshMessageView(this)
            }
        },
        // If message-view is a parent component, this function will find it and refresh its tables
        refreshMessageView (view) {
            view = view.$parent
            if (view.$el.className === 'message-view') {
                view.refresh()
            } else if (view.$parent) {
                this.refreshMessageView(view)
            }
        },
        closeModal () {
            this.$bvModal.hide(this.modalId)
            this.resetModal()
        },
        getDateTime () {
            //TODO remove and set message create/send date on backend
            const date = new Date().toISOString()
            return date.substring(0, date.indexOf('.')).replace('T', ' ')
        },
        resetModal () {
            if (!this.draft) {
                this.message = {
                    from_id: this.$store.state.currentUser.id,
                    to_id: this.recipient.id,
                    subject: null,
                    body: null,
                    status: 'UNREAD',
                    sent: null
                }
            }
        }
    }
})

</script>
